
import Vue from "vue";
import { FRadioGroup, FRadioGroupField, FTextareaField } from "@fkui/vue";
import { mapFields } from "vuex-map-fields";
import { MedvetetFel } from "@/store/types";
export default Vue.extend({
    name: "MedvetetFelForetagFieldGroup",
    components: {
        FRadioGroup,
        FRadioGroupField,
        FTextareaField,
    },
    data: () => ({
        MedvetetFel,
    }),
    computed: {
        ...mapFields(["observationer.foretagGenerell.medvetetFel", "observationer.foretagGenerell.vadGorDetMedvetet"]),
    },
});
